import "./App.css";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import LandingPageLayout from "./layout/LandingPages";
import SignUp from "./pages/auth/SignUp";
import Login from "./pages/auth/Login";
import ForgotpasswordRequest from "./pages/auth/password/ForgotpasswordRequest";
import ChangePassword from "./pages/auth/password/Changepassword";
import DashBoardLayout from "./layout/DashBoardLayout";
import FindJob from "./Component/user-dashboard/FindJob";
import MediaCard, { DashBoardJob } from "./Component/user-dashboard/Dashboard";
import { useLogoutUserMutation } from "./services/apiSlice";
import { useSelector } from "react-redux";
import { PrivateRoute } from "./Component/ProtectedRoute";
import SearchResult from "./Component/user-dashboard/find-job/SearchResult";
import SearchResultCat from "./Component/user-dashboard/find-job/SearchResultCat";
import CreateProfile from "./Component/user-dashboard/UpdateProfile";
import GetMyJob from "./Component/user-dashboard/CustomerOrBussiness/GetMyJob";
import PostJob from "./Component/user-dashboard/CustomerOrBussiness/PostJob";
import EditJob from "./Component/user-dashboard/CustomerOrBussiness/EditJob";
import { PayPals } from "./Component/PayPal";
import PageNotFound from "./Component/PageNotFound";
import ViewProfile from "./Component/viewProfile";
import CustomerActionNeeded from "./Component/user-dashboard/CustomerOrBussiness/customerActionNeeded";
import MyProfile from "./Component/MyProfile";

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutUser, { isLoading }] = useLogoutUserMutation();
  const userSignIn = useSelector((state) => state?.userSignIn);
  const { userInfo } = userSignIn;
  console.log({ userInfo });

  const timeNow = Date.now() / 1000;

  // const PrivateRoute = (props) => {
  //   let isAuthenticated = false;
  //   const token = userInfo;

  //   if (token) {
  //     try {
  //       const { _id: userID, exp: tokenExpiresAt } = jwt_decode(token);
  //       console.log(
  //         "jwt_decode",
  //         userID,
  //         "jwt_decode.exp * 1000 < new Date().getTime()",
  //         tokenExpiresAt < timeNow
  //       );
  //       if (!userID || tokenExpiresAt < timeNow) {
  //         handleLogout();
  //       } else {
  //         isAuthenticated = true;
  //       }
  //     } catch (error) {
  //       handleLogout();
  //     }
  //   }

  //   return isAuthenticated ? (
  //     <Outlet />
  //   ) : (
  //     <Navigate to="/login" replace state={{ from: location }} />
  //   );
  // };
  return (
    <>
      <Routes>
        {" "}
        <Route path="/register" element={<SignUp />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/forget-password-request"
          element={<ForgotpasswordRequest />}
        />
        <Route path="/confirm-password-request" element={<ChangePassword />} />
        <Route path="/" element={<LandingPageLayout />}>
          <Route path="/" element={<HomePage />} />
        </Route>
        <Route
          element={<PrivateRoute userInfo={userInfo} logoutUser={logoutUser} />}
        >
          <Route
            path="/dashboard"
            element={<DashBoardLayout logoutUser={logoutUser} />}
          >
            <Route path="/dashboard" element={<DashBoardJob />} />
            <Route path="sub-premium-plan" element={<PayPals />} />
            <Route path="create-profile" element={<CreateProfile />} />
            <Route path="my-job" element={<GetMyJob />} />
            <Route path="post-job" element={<PostJob />} />
            <Route path="find-job" element={<FindJob />} />
            <Route path="find-job/zip_code" element={<SearchResult />} />
            <Route path="find-job/categories" element={<SearchResultCat />} />
            <Route
              path="edit-job/:jobId"
              element={<EditJob userInfo={userInfo} />}
            />
            <Route path="customer-survey" element={<CustomerActionNeeded />} />
            <Route path="view-pro-profile" element={<ViewProfile />} />
            <Route path="my-pro-profile" element={<MyProfile />} />
          </Route>
        </Route>
        {/* <Route
          path="*"
          element={
            <main
              className="text-center text-black align-middle w-full h-full"
              style={{ padding: "1rem" }}
            >
              <p>There's nothing here! or the URL doesn't exist</p>
            </main>
          }
        /> */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}

export default App;
